module.exports = __webpack_public_path__ + "img/not-found-light.0f2b8770.svg";